<template>
  <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
    <v-snackbar v-model="snackbar" :color="snackbar_color" :timeout="2000" >
      <span>{{message}}</span>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-card class="neu-glow">
        <v-card-title primary-title>
        <div class="text-h5">{{$t(page+'.Company')}} <span class="subtitle-1">({{$t(page+'.with red background')}})</span></div>
    </v-card-title>
    <v-container grid-list-xl fluid>
    <v-row>
        <v-col md="5" cols="12">
          <v-text-field
              color="primary"
              :label="$t(page+'.Company')"
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'Company')"               
              name="Company"
              @input.native="$parent.save"
              v-model="form.Company"
              @blur="$v.form.Company.$touch()"
              required
              filled
              background-color="#ff000010"
          ></v-text-field>
        </v-col>
        <v-col md="5" cols="12">
          <v-text-field
              color="primary"
              :label="$t(page+'.Address')"
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'Address')"               
              name="Address"
              @input.native="$parent.save"
              v-model="form.Address"
              @blur="$v.form.Address.$touch()"
              required
              filled
              background-color="#ff000010"
          ></v-text-field>
        </v-col>
        <v-col md="2" sm="6" cols="12">
          <v-text-field
              color="primary"
              :label="$t(page+'.Postal Code')"
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'PostalCode')"               
              name="PostalCode"
              counter="5"
              @input.native="$parent.save"
              v-model="form.PostalCode"
              @blur="$v.form.PostalCode.$touch()"
              @input="$v.form.PostalCode.$touch()"
              required
              filled
              background-color="#ff000010"
          ></v-text-field>
        </v-col>
        <v-col md="5" cols="12">
          <v-text-field
            :label="$t(page+'.City')"
            outlined
            dense
            clearable
            clear-icon="far fa-trash-alt" 
            @click:clear="$parent.save(null,'City')"             
            name="City"
            @input.native="$parent.save"
            v-model="form.City"
            @blur="$v.form.City.$touch()"
            required
            filled
            color="primary"
            background-color="#ff000010"
          ></v-text-field>
        </v-col>
        <v-col md="3" cols="12">
          <v-select
            :label="$t(page+'.State')"
            name="StateOrProvince"
            v-model="form.StateOrProvince"
            @blur="$v.form.StateOrProvince.$touch()"
            @change="$parent.save($event, 'StateOrProvince')"
            :items="selects.ProvinciaAlboItems"
            required
            outlined
            dense
            filled
            clearable
            clear-icon="far fa-trash-alt" 
            @click:clear="$parent.save(null,'StateOrProvince')"             
            color="primary"
            background-color="#ff000010"
          ></v-select>
        </v-col>
        <v-col md="4" cols="12">
          <v-select
            :label="$t(page+'.Country')"
            v-model="form.CountryID"
            required
            outlined
            dense
            filled
            clearable
            clear-icon="far fa-trash-alt" 
            @click:clear="$parent.save(null,'CountryID')"             
            color="primary"
            background-color="#ff000010"
            name="CountryID"
            @change="$parent.save($event, 'CountryID')"
            :items="countries"
            @blur="$v.form.CountryID.$touch()"
          ></v-select>
        </v-col>
        <v-col md="4" cols="12">
          <v-text-field
              color="primary"
              :label="$t(page+'.Company ID')"
              outlined
              dense
              name="CompanyID"
              filled
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'CompanyID')"               
              counter="16"
              background-color="#ff000010"
              @input.native="$parent.save"
              v-model="form.CompanyID"
              @blur="$v.form.CompanyID.$touch()"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="12">
          <v-text-field
              color="primary"
              :label="$t(page+'.VAT Number')"
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'VATNumber')"               
              name="VATNumber"
              @input.native="$parent.save"
              v-model="form.VATNumber"
              @blur="$v.form.VATNumber.$touch()"
              counter="11"
              required
              filled
              background-color="#ff000010"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="12">
          <v-text-field
              color="primary"
              :label="$t(page+'.SDI Code')"
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'SDI')"               
              counter="7"
              name="SDI"
              @input.native="$parent.save"
              v-model="form.SDI"
              @blur="$v.form.SDI.$touch()"
          ></v-text-field>
        </v-col>
        <v-col md="8" cols="12">
          <v-text-field
              color="primary"
              :label="$t(page+'.IBAN')"
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'IBAN')"               
              counter="31"
              name="IBAN"
              @input.native="$parent.save"
              v-model="form.IBAN"
              @blur="$v.form.IBAN.$touch()"
              filled
              required
              background-color="#ff000010"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="12">
          <v-text-field
              color="primary"
              :label="$t(page+'.SWIFT')"
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'SWIFT')"               
              counter="11"
              name="SWIFT"
              @input.native="$parent.save"
              v-model="form.SWIFT"
              @blur="$v.form.SWIFT.$touch()"
              filled
          ></v-text-field>
        </v-col>
    </v-row>
    </v-container>
</v-card>
  </v-form>
</template>
<script>
import { mapGetters } from "vuex";
import { required, maxLength } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import { availableCountries  } from "@/config/countries";
import _ from 'lodash'
const defaultForm = {
  company: "",
  address: "",
  postalcode: "",
  buildingnumber:"",
  city: "",
  stateorprovince: "",
  country: "",
  companyid: "",
  vatnumber: "",
  sdi: "",
  pec:"",
  iban:"",
  swift:""
};

export default {
  props: ['form','selects'],
  mixins: [validationMixin],
  validations: {
    form: {
      company: { required },
      address: { required },
      buildingnumber: { required},
      postalcode: { required, maxLength: maxLength(8) },
      city: { required },
      stateorprovince: { required },
      country: { required },
      companyid: { required },
      vatnumber: { required },
      sdi: { required },
      pec: { required },
      iban: { required }
    },
  },
  validationMessages: {
    form: {
      company: { required: "Choose your favorite animal" },
      address: { required: "Choose your favorite animal" },
      buildingnumber: { required: "enter building name" },
      city: { required: "City is required" },
      stateorprovince: { required: "State is required" },
      country: { required: "Country is required" },
      companyid: { required: "CompanyID is required" },
      vatnumber: { required: "TAX Number is required" },
      sdi: { required: "SDI is required" },
      iban: { required: "IBAN is required" },
      postalcode: {
        required: "PostalCode is required",
        maxLength: "Max 8 characters",
      },
    },
  },
  data() {
    return {
      page: "BossAccount",
      //form: this.$store.state.userdata.user,
      countries: availableCountries,
      snackbar: false,     
      message:'',
      snackbar_color:'success', 
    };
  },
  computed: {
      ...mapGetters(["user"]),
  },
  methods: {
    resetForm() {
      this.form = Object.assign({}, defaultForm);
      this.$refs.form.reset();
      this.$v.$reset();
    },
    submit() {
      this.resetForm();
      this.$v.$reset();
    },

  },
  beforeDestroy() {
    this.form = null;
    delete this.form;
  },
};
</script>